export class NotificationFilters {
  read: string;
  day: string;
  start: Date;
  end: Date;
  size? : number;
  page? : number;
}
